import i18n from 'i18next';
import {
  ForbiddenError,
  ForbiddenErrorErrorEnum,
  BadRequestError,
  ConflictError,
  ConflictErrorErrorEnum,
  NotFoundError,
  NotFoundErrorErrorEnum,
  BadRequestErrorStatusEnum,
} from '@cdaas/api-clients/dist/asset-admin-openapi';

/**
 * Map error code returned from asset backend into a localized error message
 * @param backendError Error object returned from asset backend
 * @param defaultMessage Error message to return if the backendError is not of any specific type
 */
export const mapAssetBackendErrorCodeToLocalizedErrorMsg = (
  backendError: ForbiddenError | BadRequestError | ConflictError | NotFoundError | undefined,
  defaultMessage = '',
  parentCompanyName?: string,
  childCompanyName?: string,
): string => {
  const i18nNamespace = 'errorCodes';
  const assetAdminErrors = 'assetAdmin';
  const errorMessages = `${i18nNamespace}:${assetAdminErrors}`;

  // Handle all bad requests here
  if (backendError?.status === BadRequestErrorStatusEnum.NUMBER_400) {
    // For now handle only bad request for parent organization
    const parentOrg = backendError.fields?.find(error => error.field === 'parent_organization_id');
    if (parentOrg) {
      return i18n.t(`${errorMessages}:notAllowedParentOrganization`, { parent: parentCompanyName, child: childCompanyName });
    }
    return defaultMessage || i18n.t(`${i18nNamespace}:general`);
  }

  switch (backendError?.error) {
    case ForbiddenErrorErrorEnum.Forbidden:
      return i18n.t(`${errorMessages}:forbidden`);

    case ConflictErrorErrorEnum.EmailAlreadyInUse:
      return i18n.t(`${errorMessages}:emailAlreadyInUse`);
    case ConflictErrorErrorEnum.PhoneNumberAlreadyInUse:
      return i18n.t(`${errorMessages}:phoneNumberAlreadyInUse`);
    case ConflictErrorErrorEnum.OrganizationNumberAlreadyInUse:
      return i18n.t(`${errorMessages}:organizationNumberAlreadyInUse`);
    case ConflictErrorErrorEnum.UserGroupInUse:
      return i18n.t(`${errorMessages}:userGroupInUse`);

    case NotFoundErrorErrorEnum.OrganizationNotFound:
      return i18n.t(`${errorMessages}:organizationNotFound`);
    case NotFoundErrorErrorEnum.UserGroupNotFound:
      return i18n.t(`${errorMessages}:userGroupNotFound`);
    case NotFoundErrorErrorEnum.UserNotFound:
      return i18n.t(`${errorMessages}:userNotFound`);

    // Add more cases here as necessary
    default:
      return defaultMessage || i18n.t(`${i18nNamespace}:general`);
  }
};
